<template>
  <div style='width: 100%;'>
    <div class='sdau_search'>
      <el-form ref="form" :model="formData" label-width="100px" :inline="true">
        <el-row>
          <el-col :span='8' style='height: 62px;'>
            <el-form-item label="状态" prop="status">
              <el-radio v-for="(item, i) in statusList" v-model="formData.isPassed" :key='i' :label="item.value">{{
                item.label }}</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label="试卷分类">
              <el-select v-model="formData.testPaperTypeId" placeholder="请选择试卷分类">
                <el-option v-for='(item, index) in typeData' :key='index' :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label="设备编号">
              <el-input placeholder="请输入设预约单号" v-model="formData.equipmentNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-form-item label="设备名称">
              <el-input placeholder="请输入设备名称" v-model="formData.equipmentName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='8'>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" :index='Nindex' width="55" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="testPaperCode" label="试卷编号" align="center">
      </el-table-column>
      <el-table-column prop="equipmentNumber" width="100" label="试卷分类" align="center">
        <template slot-scope="scope">
          <div v-for="(item, i) in typeData" :key="i + 'testPaperTypeId'">
            <span v-if="scope.row.testPaperTypeId == item.dictCode">{{ item.dictLabel }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="testPaperName" label="试卷名称" align="center">
      </el-table-column>
      <el-table-column prop="minSubject" label="题目数量" align="center">
      </el-table-column>
      <el-table-column prop="totalScore" label="满分" align="center">
      </el-table-column>
      <el-table-column prop="passScore" label="及格线" align="center">
      </el-table-column>
      <el-table-column prop="reservationStartTime" width="140" label="关联设备" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showSeteqment(scope.row.id)">{{ scope.row.equipmentName
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button v-if='!Number(scope.row.isPassed)' type="text" size="small"
            @click="showexmation(scope.row)">开始考核</el-button>
          <el-button v-else type="text" size="small" @click="showexmation(scope.row)">查看试卷</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination v-show="total > 0" :pageSizes="pageSizes" :total="total" :page.sync="formData.pageNum"
      :limit.sync="formData.pageSize" @pagination='init' />
    <seteqmentTable v-if='showEqment' :showEqment='showEqment' :appraisalTestPaperId='appraisalTestPaperId'
      @cancel='showEqment = false' />
    <admissionExamination v-if='showadmissionExamination' :title='examinationTitle' :eqId='testpaperId'
      :showadmissionExamination='showadmissionExamination' @close='closeadmissionExamination'>
    </admissionExamination>
  </div>
</template>
<script>
import seteqmentTable from './seteqmentTable.vue'
export default {
  props: {},
  components: {
    seteqmentTable
  },
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 5,
        isPassed: '1',
      },
      total: 1,
      pageSizes: [5, 10, 20, 50, 100, 300],
      tableData: [],
      statusList: [
        { label: '已通过', value: '1' },
        { label: '未通过', value: '0' },
      ],
      typeData: [],
      showadmissionExamination: false,
      examinationTitle: '设备专属考试',
      testpaperId: '',
      showEqment: false
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        isPassed: this.formData.isPassed
      }
      this.init()
    },
    closeadmissionExamination() {
      this.showadmissionExamination = false
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },
    showSeteqment(id) {
      this.showEqment = true
      this.appraisalTestPaperId = id
    },
    init() {
      this.$net('/system/dict/data/type/classification_test_papers', 'get').then(res => {
        this.typeData = res.data
      })
      this.$net('/sdau/userClient/appraisalResult/paperList', 'get', this.formData).then(res => {
        this.tableData = res.data.list
      })
    },
    showexmation(row) {
      this.testpaperId = row.id
      this.showadmissionExamination = true
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table th {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #666666;
}

::v-deep .el-table td {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
}

.eq_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>